import { render, staticRenderFns } from "./ScreenLaudo3d.vue?vue&type=template&id=66f8d264&lang=true&"
import script from "./ScreenLaudo3d.vue?vue&type=script&lang=js&"
export * from "./ScreenLaudo3d.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports